import React, { useMemo, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";

import { buildMuscleComparisonChartModel } from "./muscle-comparison-chart";
import { getMuscleDetailFilterOptions } from "./muscle-area-utils";
import MuscleDetailFilterDropdown from "./MuscleDetailFilterDropdown";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
);

const resolveInitialRegions = (highlights) => {
  if (!highlights?.best?.regionLabel) {
    return [];
  }

  const regions = [highlights.best.regionLabel];
  if (
    highlights.worst?.regionLabel &&
    highlights.worst.regionLabel !== highlights.best.regionLabel
  ) {
    regions.push(highlights.worst.regionLabel);
  }

  return regions;
};

const MuscleComparisonPanel = ({ rows = [], highlights = null }) => {
  const [selectedRegions, setSelectedRegions] = useState(() =>
    resolveInitialRegions(highlights)
  );

  const filterOptions = useMemo(() => getMuscleDetailFilterOptions(rows), [rows]);

  const selectedRows = useMemo(() => {
    const rowsByLabel = new Map(rows.map((row) => [row.regionLabel, row]));
    return selectedRegions
      .map((label) => rowsByLabel.get(label))
      .filter(Boolean);
  }, [rows, selectedRegions]);

  const chartModel = useMemo(
    () => buildMuscleComparisonChartModel({ rows: selectedRows }),
    [selectedRows]
  );

  return (
    <section className="anthropometry-detailed-progress__card anthropometry-detailed-progress__card--muscle-comparison">
      <div className="anthropometry-detailed-progress__card__header">
        <div>
          <h2>Comparativo rápido</h2>
          <p>Compare os músculos que desejar no período selecionado</p>
        </div>

        <div className="anthropometry-detailed-progress__toolbar">
          <MuscleDetailFilterDropdown
            options={filterOptions}
            selectedRegions={selectedRegions}
            onChange={setSelectedRegions}
            onClear={() => setSelectedRegions([])}
            triggerLabel="Adicionar novo músculo"
            triggerVariant="primary"
            clearLabel="Limpar"
            searchPlaceholder="Buscar área muscular"
            emptySearchMessage="Nenhuma área encontrada"
          />
        </div>
      </div>

      {selectedRows.length === 0 ? (
        <div className="anthropometry-detailed-progress__panel-empty anthropometry-detailed-progress__panel-empty--compact">
          <p>Selecione um ou mais músculos para comparar</p>
        </div>
      ) : chartModel.hasValues ? (
        <div className="anthropometry-detailed-progress__muscle-comparison-chart">
          <Line data={chartModel.chartData} options={chartModel.chartOptions} />
        </div>
      ) : (
        <div className="anthropometry-detailed-progress__panel-empty anthropometry-detailed-progress__panel-empty--compact">
          <p>Não há dados suficientes para exibir a comparação no período selecionado.</p>
        </div>
      )}
    </section>
  );
};

export default MuscleComparisonPanel;
